import axios from 'axios'

// A árvore de passos monta vários componentes ao mesmo tempo e cada um só testa `getTables.length` (ainda 0 enquanto a 1ª
// resposta não volta): todos disparavam o próprio GET /subject/ (~120 KB). Chamadas simultâneas esperam a mesma resposta.
let loadTablesInFlight = null

const moduleTables = {
  state: () => ({
    tables: [],
    attributes: []
  }),
  getters: {
    getTables ({ tables }) {
      return tables
        .filter((value) => {
          return (
            value.subjectAttributes.length &&
                 value.subjectAttributes.every(
                   ({
                     subjectAttributeId,
                     subjectAttributeName,
                     attributeName
                   }) =>
                     typeof subjectAttributeId !== 'undefined' &&
                     // subjectAttributeName/attributeName podem chegar null (não só undefined) quando o
                     // Attribute referenciado por um SubjectAttribute não resolve (dado órfão do backend) —
                     // checar só "!== undefined" deixava passar um par null/null, que quebrava o .trim() do
                     // map abaixo. Aqui exige-se um texto não vazio de pelo menos um dos dois.
                     Boolean(
                       (subjectAttributeName && subjectAttributeName.trim()) ||
                         (attributeName && attributeName.trim())
                     )
                 )
          )
        })
        .map((value) => ({
          id: parseInt(value.subjectId),
          label: value.subjectName.trim(),
          identifier: value.subjectIdentifier.toLowerCase(),
          icon: value.icon,
          columns: value.subjectAttributes.map(
            ({
              subjectAttributeId,
              attributeName,
              subjectAttributeName,
              componentId,
              subjectAttributeIdentifier,
              relatedSubject,
              icon
            }) => {
              const component = {}

              component.type = componentId

              component.config = {}
              component.config.readonly = false
              component.config.required = true
              component.config.actions = {
                update: true,
                insert: true
              }

              return {
                id: parseInt(subjectAttributeId),
                label: (subjectAttributeName || attributeName || '').trim(),
                icon,
                identifier: subjectAttributeIdentifier,
                relatedSubject,
                component
              }
            }
          )
        }))
    },
    getAttributes ({ attributes }) {
      return attributes.map((value) => ({
        id: parseInt(value.attributeId),
        label: value.attributeName.trim(),
        icon: value.icon
      }))
    }
  },
  mutations: {
    SET_TABLES (state, tables) {
      state.tables = tables
    },
    SET_ATTRIBUTES (state, attributes) {
      state.attributes = attributes
    }
  },
  actions: {
    async loadTables ({ getters, commit }) {
      if (loadTablesInFlight) return loadTablesInFlight

      const request = axios
        .get(`${getters.api}/subject/`)
        .then(({ data }) => {
          commit('SET_TABLES', data.itens)
        })
        .finally(() => {
          if (loadTablesInFlight === request) loadTablesInFlight = null
        })

      loadTablesInFlight = request

      return request
    },
    async loadAttributes ({ getters, commit }) {
      await axios
        .get(`${getters.api}/attribute/`)
        .then(({ data }) => {
          commit('SET_ATTRIBUTES', data)
        })
        .catch((error) => {
          throw error
        })
    }
  }
}

export default moduleTables
